export default __webpack_public_path__ + "static/media/Darkblade's Hood of the Emissary.7fdf066a.jpg";